import React, { useRef, useEffect } from 'react';
import Sidebar from './Sidebar';
import PaymentsDisabledInfo from './PaymentsDisabledInfo';

function SidebarContainer({ isOpen, onClose }) {
  const scrollWrapperRef = useRef(null);

  useEffect(() => {
    const scrollWrapper = scrollWrapperRef.current;
    if (!scrollWrapper) return;

    const handleWheel = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = scrollWrapper;
      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
      
      // If scrolling up at top or down at bottom, prevent default to stop page scroll
      if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    };

    const handleTouchMove = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = scrollWrapper;
      const touch = e.touches[0];
      const touchY = touch.clientY;
      const rect = scrollWrapper.getBoundingClientRect();
      const isInsideSidebar = touchY >= rect.top && touchY <= rect.bottom;
      
      if (isInsideSidebar) {
        const isAtTop = scrollTop === 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
        
        if ((isAtTop && e.touches[0].clientY > touchY) || (isAtBottom && e.touches[0].clientY < touchY)) {
          e.stopPropagation();
        }
      }
    };

    scrollWrapper.addEventListener('wheel', handleWheel, { passive: false });
    scrollWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      scrollWrapper.removeEventListener('wheel', handleWheel);
      scrollWrapper.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  return (
    <div 
      ref={scrollWrapperRef}
      className={`sidebar-scroll-wrapper ${
        isOpen 
          ? 'translate-x-0 opacity-100' 
          : '-translate-x-full opacity-0 md:translate-x-0 md:opacity-100'
      }`}
      onWheel={(e) => {
        const target = e.currentTarget;
        const { scrollTop, scrollHeight, clientHeight } = target;
        const isAtTop = scrollTop === 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
        
        if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
          e.stopPropagation();
        }
      }}
    >
      <div className="sidebar-content">
        <Sidebar isOpen={isOpen} onClose={onClose} />
        <PaymentsDisabledInfo />
      </div>
      <style>{`
        .sidebar-scroll-wrapper {
          position: fixed;
          top: 5.75rem;
          left: 0;
          width: 16rem;
          margin: 0.5rem 0.5rem 0 0.5rem;
          z-index: 40;
          height: calc(100vh - 5.75rem);
          overflow-y: auto;
          overflow-x: hidden;
          transition: transform 0.3s, opacity 0.3s;
          direction: rtl;
          padding-right: 0.5rem;
          padding-bottom: 2rem;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }
        @media (min-width: 768px) {
          .sidebar-scroll-wrapper {
            top: 5.75rem;
            margin: 1.25rem 1.25rem 0 1.25rem;
            height: calc(100vh - 5.75rem - 1.25rem);
            padding-right: 1.25rem;
            padding-bottom: 3rem;
          }
        }
        .sidebar-content {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          direction: ltr;
        }
        .sidebar-content aside {
          position: relative !important;
          top: auto !important;
          left: auto !important;
          margin: 0 !important;
          transform: none !important;
          opacity: 1 !important;
        }
        .sidebar-content > div:not([class*="fixed inset-0"]) {
          position: relative !important;
          top: auto !important;
          left: auto !important;
          margin: 0 !important;
          transform: none !important;
          opacity: 1 !important;
        }
        /* Custom scrollbar styling - left side */
        .sidebar-scroll-wrapper::-webkit-scrollbar {
          width: 6px;
        }
        .sidebar-scroll-wrapper::-webkit-scrollbar-track {
          background: transparent;
        }
        .sidebar-scroll-wrapper::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
          transition: background 0.2s ease;
        }
        .sidebar-scroll-wrapper::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        /* Firefox scrollbar */
        .sidebar-scroll-wrapper {
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
        }
      `}</style>
    </div>
  );
}

export default SidebarContainer;

